<template>
	<div v-parallax-fit="parallax" class="slide-polaroid">
		<img src="/themes/rise-theme/dist/images/estate/character-view/henry/03_family01.png">
	</div>
</template>

<script>
	export default {
		data() {
			return {
				parallax: [
					{
						start: 800,
						end: 1200,
						fromStyle: { transform: 'translateY(0%) translateX(0%) rotate(0deg)', opacity: 0 },
           				toStyle: { transform: 'translateY(-53%) translateX(0%) rotate(0deg)', opacity: 1 },
						easing: 'linear'
					},
					{
						start: 4100,
						end: 5200,
						fromStyle: { transform: 'translateY(-53%) translateX(0%) rotate(0deg)', opacity: 1 },
           				toStyle: { transform: 'translateY(-70%) translateX(-1000%) rotate(-25deg)', opacity: 1 },
						easing: 'linear'
					}
				]
			}
		}
	}
</script>

<style lang="scss" scoped>
	.slide-polaroid {
		max-width: 150px;
		position: absolute;
		left: 7%;
		top: 100%;
		z-index: 2;
		transition: all 0.1s linear;
	}

	@media screen and (max-width: 1680px) {
		.slide-polaroid {
			max-width: 120px;
			left: 9%;
			top: 108%;
		}
	}

	@media screen and (max-width: 1280px) {
		.slide-polaroid {
			max-width: 70px;
			left: 10%;
			top: 107%;
		}
	}

	@media screen and (max-width: 650px) {
		.slide-polaroid {
			max-width: 39px;
			left: 12%;
		}
	}
</style>
